import Modal from 'components/modal';
import SendReplyMSG from 'components/modal/sendReplyMSG';
import moment from 'jalali-moment';
import React, {useState} from 'react';
import ParticipatedCard from '../ParticipatedCard';
interface RregisteredOffersAuctionItemProps {
  index: number;
  created_at: string;
  price: number;
  postType: string;
  guid: string;
  profile_type: string;
  participated_auctions: number;
  name: string;
  img: string | null;
  is_saled: boolean;
}
const RregisteredOffersAuctionItem = ({
  index,
  created_at,
  price,
  postType,
  profile_type,
  guid,
  participated_auctions,
  name,
  img,
  is_saled,
}: RregisteredOffersAuctionItemProps) => {
  const [isSendMSGOpen, setIsSendMSGOpen] = useState<boolean>(false);
  const [isOpenModalParticipated, setisOpenModalParticipated] =
    useState<boolean>(false);

  return (
    <>
      <div className="flex w-full items-center justify-between py-3 text-green-1">
        <div className="pr-3 w-[10%] flex items-center justify-center">
          {index}
        </div>
        <div className="text-gray-6 w-[25%] flex items-center justify-center">
          {moment(created_at).format('jYYYY/jMM/jDD')}
        </div>
        <div className="text-gray-6 w-[25%] flex items-center justify-center">
          {price}
        </div>
        <div className="w-[20%] flex items-center justify-center">
          <button
            className="icon-account text-[20px] "
            onClick={() => setisOpenModalParticipated(prev => !prev)}
          />
        </div>
        <div className=" w-[20%] flex items-center justify-center">
          <button
            disabled={is_saled}
            className="icon-chat pl-2 text-[20px]"
            onClick={() => setIsSendMSGOpen(prev => !prev)}
          />
        </div>
      </div>
      <Modal isOpen={isSendMSGOpen} setIsOpen={setIsSendMSGOpen}>
        <SendReplyMSG
          post={guid}
          setIsOpen={setIsSendMSGOpen}
          post_type={postType}
          profile_type={profile_type}
        />
      </Modal>
      <Modal
        isOpen={isOpenModalParticipated}
        setIsOpen={setisOpenModalParticipated}
      >
        <ParticipatedCard
          is_saled={is_saled}
          cardType="auction"
          guid={guid}
          name={name}
          image={img}
          participated_auctions={participated_auctions}
          setIsOpenModal={setisOpenModalParticipated}
        />
      </Modal>
    </>
  );
};

export default RregisteredOffersAuctionItem;
